import { AdditiveBlending, FrontSide } from "three";
import { LINE_INSTANCE_SHADER } from "./instance.shader";
import { RenderOrder } from "../../RenderOrder";
import { CustomShaderMaterial } from "../../shader/CustomShaderMaterial";
import { renderer } from "../../RendererGlobals";
export var InstanceBatchLineMaterial;
(function (InstanceBatchLineMaterial) {
    InstanceBatchLineMaterial["FUZZY_LINE"] = "FUSSY_LINE";
    InstanceBatchLineMaterial["BASIC_LINE"] = "BASIC_LINE";
    InstanceBatchLineMaterial["LASER"] = "LASER";
})(InstanceBatchLineMaterial || (InstanceBatchLineMaterial = {}));
export function createLineMaterial(lineType) {
    const materialOptions = {
        uniforms: LINE_INSTANCE_SHADER.uniforms,
        vertexShader: LINE_INSTANCE_SHADER.vertexShader,
        fragmentShader: LINE_INSTANCE_SHADER.fragmentShader,
        lights: false,
        side: FrontSide,
        wireframe: false,
        transparent: true
    };
    switch (lineType) {
        case InstanceBatchLineMaterial.FUZZY_LINE:
            {
                materialOptions.defines = { FUZZY_LINE: "" };
                if (renderer.capabilities.isWebGL2) {
                    materialOptions.defines.WRITE_DEPTH = "";
                }
                materialOptions.alphaTest = 0.01;
            }
            break;
        case InstanceBatchLineMaterial.BASIC_LINE:
            {
                materialOptions.defines = { BASIC_LINE: "" };
                materialOptions.alphaTest = 0.5;
            }
            break;
        case InstanceBatchLineMaterial.LASER:
            {
                materialOptions.defines = { LASER: "" };
                materialOptions.alphaTest = 0.01;
                materialOptions.blending = AdditiveBlending;
                materialOptions.depthWrite = false;
            }
            break;
    }
    return new CustomShaderMaterial(materialOptions);
}
export function getLineRenderOrder(lineType) {
    switch (lineType) {
        case InstanceBatchLineMaterial.LASER:
            return RenderOrder.LASER;
        default:
            return RenderOrder.LINES;
    }
}
